// // VFXCinematic.js
// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import "./Animation.css"; // <-- import the CSS file below

// // react-icons for small icons
// import { FaFire, FaWind, FaBolt, FaObjectGroup, FaPlay } from "react-icons/fa";

// export default function VFX() {
//   useEffect(() => {
//     AOS.init({ duration: 800, once: true, offset: 80 });
//     window.scrollTo(0, 0);
//   }, []);

//   // sample data
//   const effectCards = [
//     {
//       title: "Fire & Ember FX",
//       desc: "Layered fire simulations, emissive lighting & realistic compositing.",
//       icon: <FaFire className="text-red-500" />,
//       anim: "fx-shake",
//     },
//     {
//       title: "Volumetric Smoke",
//       desc: "Real-time smoke passes, density control & color grading for atmosphere.",
//       icon: <FaWind className="text-slate-600" />,
//       anim: "fx-float",
//     },
//     {
//       title: "Lightning & Sparks",
//       desc: "Procedural electricity, spark emitters and light wraps for realism.",
//       icon: <FaBolt className="text-yellow-500" />,
//       anim: "fx-strobe",
//     },
//     {
//       title: "Particles & Debris",
//       desc: "Massive particle systems and destruction fragments for cinematic shots.",
//       icon: <FaObjectGroup className="text-indigo-500" />,
//       anim: "fx-pulse",
//     },
//   ];

//   const timeline = [
//     { step: "Previs & Concept", text: "Storyboard, previs and VFX planning." },
//     { step: "On-set Data", text: "Reference plates, camera tracking, lens data." },
//     { step: "3D + Sim", text: "Modeling, texturing, sims (smoke, fire, fluids)." },
//     { step: "Matchmove", text: "Camera solve, object tracking & stabilization." },
//     { step: "Compositing", text: "Layer passes, color match, retime & finishing." },
//     { step: "Delivery", text: "Final render, codecs & pipeline handoff." },
//   ];

//   const careers = [
//     { title: "Compositor", note: "Integrate CGI into live footage." },
//     { title: "FX Artist", note: "Simulate fire, smoke, fluids & destruction." },
//     { title: "Matchmover / Tracking Artist", note: "Solve camera moves for CG integration." },
//     { title: "Look Dev / Lighting Artist", note: "Define surface and lighting realism." },
//   ];

//   return (
//     <div className="min-h-screen bg-white text-black font-sans">
//       {/* HERO: video background */}
//       <section className="relative h-screen overflow-hidden">
//         {/* Background video - replace src with your own trailer for production */}
//         <video
//           autoPlay
//           muted
//           loop
//           playsInline
//           className="absolute inset-0 w-full h-full object-cover filter brightness-75"
//           poster="https://lakshyaanimation.com/Dashboard/web-content/Course_Background/25/2/special%20fx.jpg"
//         >
//           {/* <source src="" type="video/mp4" /> */}
//         </video>

//         {/* overlay */}
//         <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />

//         <div className="relative z-10 max-w-6xl mx-auto px-6 h-full flex flex-col justify-center items-start">

//           <h1 data-aos="fade-up" className="text-5xl md:text-6xl font-extrabold leading-tight text-white drop-shadow-lg">
//             VFX Studio — Cinematic Visual Effects Course
//           </h1>

//           <p data-aos="fade-up" data-aos-delay="120" className="mt-4 max-w-2xl text-white/90 text-lg">
//             Learn film-grade compositing, particle simulations, matchmoving and look development — the pipeline used in blockbusters.
//           </p>

//           <div data-aos="fade-up" data-aos-delay="240" className="mt-8 flex gap-4">
//             <a href="/contact" className="inline-flex items-center gap-3 bg-white text-black px-5 py-3 rounded-lg font-semibold shadow hover:scale-105 transform transition">
//               <FaPlay /> Apply Now
//             </a>
//             <a href="#curriculum" className="inline-flex items-center gap-3 border border-white/30 text-white px-5 py-3 rounded-lg hover:bg-white/10 transition">
//               Curriculum
//             </a>
//           </div>
//         </div>

//         {/* cinematic decorative gradient strip */}
//         <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white/10 to-transparent pointer-events-none" />
//       </section>

//       {/* EFFECT CARDS - animated */}
//       <section id="effects" className="py-16 bg-white">
//         <div className="max-w-6xl mx-auto px-6">
//           <h2 className="text-3xl font-bold mb-6" data-aos="fade-up">Signature Effects Lab</h2>
//           <p className="text-gray-700 mb-8" data-aos="fade-up" data-aos-delay="80">
//             Each lab focuses on practical shots — compositing, sims, particles and lighting.
//           </p>

//           <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {effectCards.map((c, idx) => (
//               <div
//                 key={idx}
//                 data-aos={idx % 2 === 0 ? "fade-up" : "fade-down"}
//                 data-aos-delay={idx * 120}
//                 className={`relative overflow-hidden rounded-2xl p-6 bg-gradient-to-br from-gray-50 to-gray-100 shadow-lg transform transition hover:scale-105 ${c.anim}`}
//               >
//                 <div className="absolute -top-10 -right-10 w-40 h-40 bg-gradient-to-br from-white/60 to-transparent blur-2xl opacity-40 rotate-45 pointer-events-none" />
//                 <div className="flex items-center gap-4">
//                   <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-white shadow">
//                     <div className="text-2xl">{c.icon}</div>
//                   </div>
//                   <div>
//                     <h3 className="font-semibold text-lg">{c.title}</h3>
//                     <p className="text-sm text-gray-700 mt-1">{c.desc}</p>
//                   </div>
//                 </div>

//                 {/* animated small overlay */}
//                 <div className="absolute bottom-4 left-4 text-xs text-gray-500">Hands-on shot</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* TIMELINE: vertical */}
//       <section id="curriculum" className="py-16">
//         <div className="max-w-5xl mx-auto px-6">
//           <h2 className="text-3xl font-bold mb-10" data-aos="fade-up">Course Journey — Production Pipeline</h2>

//           <div className="relative">
//             <div className="absolute left-5 top-0 bottom-0 w-px bg-gradient-to-b from-purple-400 to-indigo-400" />
//             <div className="space-y-10 pl-12">
//               {timeline.map((t, i) => (
//                 <div key={i} className="relative" data-aos="fade-up" data-aos-delay={i * 120}>
//                   <div className="absolute -left-8 -mt-1 w-6 h-6 rounded-full bg-white border-4 border-purple-500 shadow" />
//                   <h4 className="font-semibold text-lg">{t.step}</h4>
//                   <p className="text-gray-700 mt-2">{t.text}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CAREERS flip cards */}
//       <section className="py-16">
//         <div className="max-w-6xl mx-auto px-6">
//           <h2 className="text-3xl font-bold mb-8" data-aos="fade-up">Careers & Roles</h2>

//           <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {careers.map((c, idx) => (
//               <div key={idx} data-aos="flip-up" data-aos-delay={idx * 120} className="perspective">
//                 <div className="relative h-44 [transform-style:preserve-3d] transition-transform duration-700 hover:[transform:rotateY(180deg)]">
//                   {/* front */}
//                   <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-white to-gray-100 shadow p-6 [backface-visibility:hidden]">
//                     <h3 className="font-semibold">{c.title}</h3>
//                     <p className="text-sm text-gray-600 mt-2">Explore creative set pieces & forward shots.</p>
//                   </div>
//                   {/* back */}
//                   <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-purple-600 to-indigo-600 text-white p-6 [transform:rotateY(180deg)] [backface-visibility:hidden]">
//                     <h3 className="font-semibold text-lg">{c.title}</h3>
//                     <p className="text-sm mt-2">{c.note}</p>
//                     <div className="mt-4 text-xs opacity-80">Avg. Salary: Industry dependent</div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* MISSION BRIEFING (FAQ) */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-4xl mx-auto px-6">
//           <h2 className="text-3xl font-bold mb-6 text-center" data-aos="fade-up">Mission Briefing — FAQ</h2>
//           <div className="space-y-4">
//             <details className="group p-4 border rounded-lg bg-white" open data-aos="fade-up">
//               <summary className="flex justify-between cursor-pointer font-medium">
//                 What hardware do I need on day one?
//                 <span className="text-sm text-gray-500">Brief</span>
//               </summary>
//               <div className="mt-3 text-gray-700">
//                 A modern laptop/workstation with a multi-core CPU and a decent GPU (4GB+) is recommended. We'll provide cloud render options for heavier sims.
//               </div>
//             </details>

//             <details className="group p-4 border rounded-lg bg-white" data-aos="fade-up" data-aos-delay="80">
//               <summary className="flex justify-between cursor-pointer font-medium">
//                 Which software is taught?
//                 <span className="text-sm text-gray-500">Tools</span>
//               </summary>
//               <div className="mt-3 text-gray-700">
//                 Primary focus: Nuke/After Effects for compositing, Houdini or Blender for sims, and Maya/Blender for 3D pipelines.
//               </div>
//             </details>

//             <details className="group p-4 border rounded-lg bg-white" data-aos="fade-up" data-aos-delay="160">
//               <summary className="flex justify-between cursor-pointer font-medium">
//                 Do you provide job support?
//                 <span className="text-sm text-gray-500">Outcome</span>
//               </summary>
//               <div className="mt-3 text-gray-700">
//                 Yes — portfolio reviews, showreel feedback, mock interviews and pipeline introductions with partner studios.
//               </div>
//             </details>
//           </div>

//           <div className="mt-10 text-center" data-aos="zoom-in">
//             <a href="/contact" className="inline-block px-6 py-3 rounded-full bg-purple-700 text-white font-semibold hover:bg-purple-800 transition animate-bounce-slow">
//               Enroll — Start Your VFX Reel
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// VFXCinematic.js
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaFire,
  FaWind,
  FaBolt,
  FaObjectGroup,
  FaPlay,
  FaUserTie,
  FaMagic,
  FaCubes,
  FaLightbulb,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function VFX() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 80 });
    window.scrollTo(0, 0);
  }, []);

  const effectCards = [
    {
      title: "Fire & Ember FX",
      desc: "Layered fire simulations, emissive lighting & realistic compositing.",
      icon: <FaFire className="text-red-500" />,
      anim: "fx-shake",
    },
    {
      title: "Volumetric Smoke",
      desc: "Real-time smoke passes, density control & color grading for atmosphere.",
      icon: <FaWind className="text-slate-600" />,
      anim: "fx-float",
    },
    {
      title: "Lightning & Sparks",
      desc: "Procedural electricity, spark emitters and light wraps for realism.",
      icon: <FaBolt className="text-yellow-500" />,
      anim: "fx-strobe",
    },
    {
      title: "Particles & Debris",
      desc: "Massive particle systems and destruction fragments for cinematic shots.",
      icon: <FaObjectGroup className="text-indigo-500" />,
      anim: "fx-pulse",
    },
  ];

  const timeline = [
    { step: "Previs & Concept", text: "Storyboard, previs and VFX planning." },
    {
      step: "On-set Data",
      text: "Reference plates, camera tracking, lens data.",
    },
    {
      step: "3D + Sim",
      text: "Modeling, texturing, sims (smoke, fire, fluids).",
    },
    {
      step: "Matchmove",
      text: "Camera solve, object tracking & stabilization.",
    },
    {
      step: "Compositing",
      text: "Layer passes, color match, retime & finishing.",
    },
    { step: "Delivery", text: "Final render, codecs & pipeline handoff." },
  ];

  const careers = [
    {
      title: "Compositor",
      note: "Integrate CGI into live footage.",
      icon: <FaUserTie className="text-purple-500 text-3xl mb-2" />,
    },
    {
      title: "FX Artist",
      note: "Simulate fire, smoke, fluids & destruction.",
      icon: <FaMagic className="text-orange-500 text-3xl mb-2" />,
    },
    {
      title: "Matchmover / Tracking Artist",
      note: "Solve camera moves for CG integration.",
      icon: <FaCubes className="text-blue-500 text-3xl mb-2" />,
    },
    {
      title: "Look Dev / Lighting Artist",
      note: "Define surface and lighting realism.",
      icon: <FaLightbulb className="text-yellow-500 text-3xl mb-2" />,
    },
  ];

  return (
    <div className="min-h-screen bg-white text-black">
      {/* Hero Section */}
      <section className="relative h-[80vh] overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover filter brightness-75"
          poster="/assets/special fx.jpg"
        ></video>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />
        <div className="relative z-10 max-w-6xl mx-auto px-6 h-full flex flex-col justify-center items-start">
          <h1
            data-aos="fade-up"
            className="text-4xl md:text-5xl font-extrabold leading-tight text-white drop-shadow-lg animate-float"
          >
            VFX Studio — Cinematic Visual Effects Course
          </h1>
          <p
            data-aos="fade-up"
            data-aos-delay="120"
            className="mt-4 max-w-2xl text-white/90 text-lg"
          >
            Learn film-grade compositing, particle simulations, matchmoving and
            look development — the pipeline used in blockbusters.
          </p>
          <div
            data-aos="fade-up"
            data-aos-delay="240"
            className="mt-6 flex gap-4"
          >
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 bg-white text-black px-5 py-3 rounded-lg font-semibold shadow hover:scale-105 transform transition"
            >
              <FaPlay /> Apply Now
            </Link>
          </div>
        </div>
      </section>

      {/* Signature Effects Lab */}
      <section id="effects" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-6" data-aos="fade-up">
            Signature Effects Lab
          </h2>
          <p
            className="text-gray-700 mb-8"
            data-aos="fade-up"
            data-aos-delay="80"
          >
            Each lab focuses on practical shots — compositing, sims, particles
            and lighting.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {effectCards.map((c, idx) => (
              <div
                key={idx}
                data-aos={idx % 2 === 0 ? "fade-up" : "fade-down"}
                data-aos-delay={idx * 120}
                className={`corner-card relative overflow-hidden rounded-2xl p-6 bg-gradient-to-br from-gray-50 to-gray-100 shadow-lg transform transition hover:scale-105 ${c.anim} shake-hover`}
              >
                <div className="flex items-center gap-4 animate-bounce">
                  <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-white shadow">
                    <div className="text-2xl animate-wiggle">{c.icon}</div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg">{c.title}</h3>
                    <p className="text-sm text-gray-700 mt-1">{c.desc}</p>
                  </div>
                </div>
                {/* bottom-right corner */}
                <div className="absolute bottom-0 right-0 w-8 h-8 border-4 border-blue-600 rounded-br-xl pointer-events-none" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section id="curriculum" className="py-16">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-10" data-aos="fade-up">
            Course Journey — Production Pipeline
          </h2>
          <div className="relative">
            <div className="absolute left-5 top-0 bottom-0 w-px bg-gradient-to-b from-purple-400 to-indigo-400" />
            <div className="space-y-10 pl-12">
              {timeline.map((t, i) => (
                <div
                  key={i}
                  className="relative"
                  data-aos="fade-up"
                  data-aos-delay={i * 120}
                >
                  <div className="absolute -left-8 -mt-1 w-6 h-6 rounded-full bg-white border-4 border-purple-500 shadow" />
                  <h4 className="font-semibold text-lg">{t.step}</h4>
                  <p className="text-gray-700 mt-2">{t.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Careers & Roles */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-8" data-aos="fade-up">
            Careers & Roles
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {careers.map((c, idx) => (
              <div
                key={idx}
                data-aos="flip-up"
                data-aos-delay={idx * 120}
                className="corner-card perspective"
              >
                <div className="relative h-44 [transform-style:preserve-3d] transition-transform duration-700 hover:[transform:rotateY(180deg)] shake-hover animate-float">
                  {/* front */}
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-white to-gray-100 shadow p-6 flex flex-col items-center justify-center [backface-visibility:hidden]  animate-pulse">
                    {c.icon}
                    <h3 className="font-semibold text-center">{c.title}</h3>
                    <p className="text-sm text-gray-600 mt-2 text-center">
                      Explore creative set pieces & forward shots.
                    </p>
                  </div>
                  {/* back */}
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-purple-600 to-indigo-600 text-white p-6 flex flex-col items-center justify-center [transform:rotateY(180deg)] [backface-visibility:hidden]">
                    <h3 className="font-semibold text-lg text-center">
                      {c.title}
                    </h3>
                    <p className="text-sm mt-2 text-center">{c.note}</p>
                    <div className="mt-4 text-xs opacity-80 text-center">
                      Avg. Salary: Industry dependent
                    </div>
                  </div>
                  {/* bottom-right corner */}
                  <div className="absolute bottom-0 right-0 w-8 h-8 border-4 border-blue-600 rounded-br-xl pointer-events-none" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2
            className="text-3xl font-bold mb-6 text-center"
            data-aos="fade-up"
          >
            Mission Briefing — FAQ
          </h2>
          <div className="space-y-4">
            <details
              className="group p-4 border-l-8 border-purple-500 rounded-lg bg-gradient-to-r from-purple-50 to-white shadow hover:shadow-lg animate-float"
              open
              data-aos="fade-up"
            >
              <summary className="flex justify-between cursor-pointer font-medium">
                What hardware do I need on day one?
                <span className="text-sm text-gray-500">Brief</span>
              </summary>
              <div className="mt-3 text-gray-700">
                A modern laptop/workstation with a multi-core CPU and a decent
                GPU (4GB+) is recommended. We'll provide cloud render options
                for heavier sims.
              </div>
            </details>

            <details
              className="group p-4 border-l-8 border-green-500 rounded-lg bg-gradient-to-r from-green-50 to-white shadow hover:shadow-lg animate-pulse"
              data-aos="fade-up"
              data-aos-delay="80"
            >
              <summary className="flex justify-between cursor-pointer font-medium">
                Which software is taught?
                <span className="text-sm text-gray-500">Tools</span>
              </summary>
              <div className="mt-3 text-gray-700">
                Primary focus: Nuke/After Effects for compositing, Houdini or
                Blender for sims, and Maya/Blender for 3D pipelines.
              </div>
            </details>

            <details
              className="group p-4 border-l-8 border-pink-500 rounded-lg bg-gradient-to-r from-pink-50 to-white shadow hover:shadow-lg animate-shake"
              data-aos="fade-up"
              data-aos-delay="160"
            >
              <summary className="flex justify-between cursor-pointer font-medium">
                Do you provide job support?
                <span className="text-sm text-gray-500">Outcome</span>
              </summary>
              <div className="mt-3 text-gray-700">
                Yes — portfolio reviews, showreel feedback, mock interviews and
                pipeline introductions with partner studios.
              </div>
            </details>
          </div>

          <div className="mt-10 text-center" data-aos="zoom-in">
            <Link
              to="/contact"
              className="inline-block px-6 py-3 rounded-full bg-purple-700 text-white font-semibold hover:bg-purple-800 transition animate-bounce-slow"
            >
              Enroll — Start Your VFX Reel
            </Link>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translate(0,0) rotate(0deg); }
            20% { transform: translate(-2px,2px) rotate(-1deg); }
            40% { transform: translate(2px,-2px) rotate(1deg); }
            60% { transform: translate(-2px,2px) rotate(0deg); }
            80% { transform: translate(2px,-1px) rotate(1deg); }
            100% { transform: translate(0,0) rotate(0deg); }
          }
          .shake-hover:hover { animation: shake 0.5s ease-in-out; }
          .corner-card { position: relative; overflow: hidden; }
          .corner-card::after {
            content: '';
            position: absolute;
            width: 30px;
            height: 30px;
            border: 3px solid blue;
            bottom: 0;
            right: 0;
            border-left: none;
            border-top: none;
          }
        `}
      </style>
    </div>
  );
}
